import {NavLink} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {cn} from '@/lib/utils'

/** Orden de §10 de `docs/modulos/perfil-cargo-spec.md`. `end` en la primera: sin él
 * queda activa también sobre sus hijas. */
export function PerfilCargoTabs({businessId, positionId}: {businessId: string; positionId: string}) {
  const {t} = useTranslation()
  const base = `/businesses/${businessId}/sgsst/perfiles-cargo/${positionId}`
  const pestanas = [
    {to: base, clave: 'perfil', end: true, testid: 'perfil-tab-perfil'},
    {to: `${base}/condiciones`, clave: 'condiciones', end: false, testid: 'perfil-ir-a-condiciones'},
    {to: `${base}/requisitos`, clave: 'requisitos', end: false, testid: 'perfil-ir-a-requisitos'},
    {to: `${base}/preguntas`, clave: 'preguntas', end: false, testid: 'perfil-ir-a-preguntas'},
    {to: `${base}/aprende`, clave: 'aprende', end: false, testid: 'perfil-ir-a-aprende'},
    {to: `${base}/versiones`, clave: 'versiones', end: false, testid: 'perfil-ir-a-versiones'},
  ]
  return (
    <nav className="flex flex-wrap gap-4 border-b" data-testid="perfil-cargo-tabs">
      {pestanas.map((pestana) => (
        <NavLink
          key={pestana.clave}
          to={pestana.to}
          end={pestana.end}
          data-testid={pestana.testid}
          className={({isActive}) =>
            cn(
              'border-b-2 px-1 pb-2 text-sm',
              isActive ? 'border-primary text-foreground' : 'border-transparent text-muted-foreground'
            )
          }>
          {t(`perfilCargo.tabs.${pestana.clave}`)}
        </NavLink>
      ))}
    </nav>
  )
}
